import { Config } from "src/constants";
import { StringService } from "src/services";

export const Donut: React.FC<{ title: string, value: number, base: number }> = ({ title, value, base }) => {

    const strokeWidth = 6;
    const radius = 70;

    const percent = 100 * value / base;

    // If more than 50% filled we need to switch arc drawing mode from less than 180 deg to more than 180 deg
    const largeArc = percent < 50 ? 0 : 1;

    // Where to put x coordinate of center of circle
    const x = 100;

    // Where to put y coordinate of center of circle
    const y = 100 - radius;

    // Calculate length of arc in radians
    const radians = ((((percent / 100) * 360) - 180) * Math.PI) / 180;

    // Calculate X coordinate of end of arc (+ 100 to move it to middle of image)
    // add some rounding error to make arc not disappear at 100%
    const endX = -Math.sin(radians) * radius + 100 - 0.0001;

    // Calculate Y coordinate of end of arc (+ 100 to move it to middle of image)
    const endY = Math.cos(radians) * radius + 100;


    // If we reach full circle we need to complete the circle, this ties into the rounding error in X coordinate above
    const z = percent === 100 ? 'z' : '';

    const dBg = "M " + x + " " + y + " A " + radius + " " + radius + " 0 1 1 " + (x - 0.0001) + " " + y + " z";

    const d = "M " + x + " " + y + " A " + radius + " " + radius + " 0 " + largeArc + " 1 " + endX + " " + endY + " " + z;

    return (
        <div className="donut-container">
            <svg
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 200 200">
                <path
                    d={dBg}
                    stroke="#444"
                    strokeWidth={strokeWidth}
                    fill="transparent"
                />
                <path
                    v-if="showLabel"
                    d={d}
                    stroke={Config.primaryColor}
                    strokeWidth={strokeWidth}
                    fill="transparent"
                />
            </svg>
            <span className="chart-label text-rtl">{StringService.toFixed(value, 2)}</span>
        </div>
    );
};